import { LocationState } from './location.models';
import { createReducer, on } from '@ngrx/store';
import * as locationActions from './location.actions';

import * as paginationConstants from '../../../shared/constants/pagination.constants';

export const initialLocationState: LocationState = {
  locations: [],
  locationsPage: null,
  pagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  locationFilter: null,
  loading: false,
  error: null,
  locationPageMetadata: null,
};

export const locationsReducer = createReducer(
  initialLocationState,
  on(locationActions.loadLocationList, (state) => ({
    ...state,
    loading: true,
  })),
  on(locationActions.loadLocationListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'Error',
  })),
  on(
    locationActions.loadLocationListSuccess,
    (state, { locationsResponse }) => ({
      ...state,
      loading: false,
      error: null,
      locations: locationsResponse.result ?? [],
      locationsPage: {
        ...state.locationsPage,
        totalCount: locationsResponse.total ?? 0,
        pageIndex: locationsResponse.pageIndex ?? 0,
        pageSize: locationsResponse.pageSize ?? 0,
      },
      locationPageMetadata: locationsResponse.metadata,
    })
  ),
  on(locationActions.saveLocation, (state) => ({ ...state, loading: true })),
  on(locationActions.saveLocationSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(locationActions.saveLocationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error?.errorMessage ?? 'Error',
  })),
  on(locationActions.updateLocationFilter, (state, { filter }) => ({
    ...state,
    locationFilter: filter,
  })),
  on(locationActions.changePagination, (state, { pageIndex, pageSize }) => ({
    ...state,
    pagination: {
      pageIndex,
      pageSize,
    },
  })),
  on(locationActions.loadLocationFilterParameters, (state) => ({
    ...state,
    loading: true,
    locationFilterParameters: null,
  })),
  on(locationActions.loadLocationFilterParametersSuccess, (state, { filterParameters }) => ({
    ...state,
    loading: false,
    locationFilterParameters: {
      ...filterParameters,
    },
  })),
  on(locationActions.loadLocationFilterParametersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(locationActions.loadLocationSuccess, (state, { location }) => ({
    ...state,
    currentLocation: location
  })),
  on(locationActions.updateLocationSuccess, (state, { location }) => ({
    ...state,
    currentLocation: location
  })),
  on(locationActions.updateLocationStatus, (state, { status }) => ({
    ...state,
    previousLocationStatus: state.currentLocation?.status ?? null,
    currentLocation: { ...state.currentLocation, status }
  })),
  on(locationActions.updateLocationStatusSuccess, (state) => ({
    ...state,
    previousLocationStatus: null
  })),
  on(locationActions.updateLocationStatusFailure, (state) => ({
    ...state,
    previousLocationStatus: null,
    currentLocation: { ...state.currentLocation, status: state.previousLocationStatus }
  })),
  on(locationActions.loadManagementUpdated, (state, { gridCapacity }) => ({
    ...state,
    currentLocation: { ...state.currentLocation, gridLimitInKwh: gridCapacity }
  }))
);
